import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "edit-police pt-0" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "edit-police__head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "edit-police__head__title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Editar Póliza")
  ])
], -1)
const _hoisted_5 = { class: "edit-police__body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "d-none"
}, "Numero de poliza", -1)
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-4" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_28 = { class: "col-3 edit-police__body__cancel" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "edit-police__body__box" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "edit-police__body__box__space" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", null, "Estado de la póliza", -1)
const _hoisted_40 = { class: "row mb-2" }
const _hoisted_41 = {
  key: 0,
  class: "col-3"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", { class: "text-danger" }, "Anulada", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "col-3" }
const _hoisted_45 = { class: "police-state" }
const _hoisted_46 = { class: "col-4" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "edit-police__body__box" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "edit-police__body__box__space" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h4", { class: "text-main mt-2 mb-2" }, " Débito automático ", -1)
const _hoisted_57 = { class: "row mb-2" }
const _hoisted_58 = { class: "col-3" }
const _hoisted_59 = {
  key: 0,
  class: "col-4"
}
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "edit-police__body__box" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "edit-police__body__box__space" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h4", { class: "text-main mt-2 mb-2" }, " Información de la póliza ", -1)
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-10" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Importe mensual", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  style: {"position":"relative"}
}, "Fecha de fin de plan", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu fecha de nacimiento", -1)
const _hoisted_73 = { class: "form-group mt-2 text-right mb-2" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { key: 0 }
const _hoisted_76 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "edit-police__body__box" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "edit-police__body__box__space" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h4", { class: "text-main mt-2 mb-2" }, " Información del Cliente ", -1)
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-10" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", {
  class: "title",
  for: ""
}, "Número de documento", -1)
const _hoisted_85 = { class: "edit-police__body__box__input-email" }
const _hoisted_86 = { class: "input-group mb-3" }
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  class: "title",
  for: ""
}, "Correo Electronico", -1)
const _hoisted_90 = { class: "edit-police__body__box__input-email" }
const _hoisted_91 = { class: "form-group mt-2 text-right mb-2 d-flex justify-content-end" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { key: 0 }
const _hoisted_94 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_95 = {
  key: 0,
  class: "edit-police__body__box"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "edit-police__body__box__space" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-2 mb-2" }, "Importes mensuales", -1)
const _hoisted_98 = { class: "table table-hover table-striped" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("th", null, "N", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("th", null, "Tipo", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("th", null, "Fecha de vencimiento", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("th", null, "Importe", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("th", null, "Código de pago", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("th", null, "Estado", -1)
const _hoisted_106 = { key: 0 }
const _hoisted_107 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_108 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_109 = {
  key: 2,
  class: "badge badge-info"
}
const _hoisted_110 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_111 = {
  key: 4,
  class: "badge badge-warning"
}
const _hoisted_112 = {
  key: 5,
  class: "badge badge-info"
}
const _hoisted_113 = { key: 0 }
const _hoisted_114 = ["onClick"]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-invoice-dollar" }, null, -1)
const _hoisted_116 = { class: "quote__step mt-0" }
const _hoisted_117 = { action: "" }
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-12" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head pt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle fa-3x" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Éxito")
], -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head" }, [
  /*#__PURE__*/_createElementVNode("p", null, "La póliza fue actualizada correctamente.")
], -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head pt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle fa-3x" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Éxito")
], -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head" }, [
  /*#__PURE__*/_createElementVNode("p", null, "El correo del usuario fue actualizado correctamente.")
], -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Devolución de Primas")
  ])
], -1)
const _hoisted_126 = { class: "modal-blue__head" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 info" }, " ¿Deseas devolver las primas pagadas del usuario? ", -1)
const _hoisted_128 = { class: "content-btn d-flex justify-content-between mt-2 mb-2" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Anulación y Devolución")
  ])
], -1)
const _hoisted_130 = { class: "modal-blue__head" }
const _hoisted_131 = { class: "table table-hover table-striped mt-3" }
const _hoisted_132 = {
  class: "form-check m-auto",
  style: {"width":"25px"}
}
const _hoisted_133 = ["checked"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: 'payments'
}, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("th", null, "Tipo", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("th", null, "Fecha de vencimiento", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("th", null, "Fecha de pago", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("th", null, "Importe", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_140 = { key: 0 }
const _hoisted_141 = {
  class: "form-check m-auto",
  style: {"width":"25px"}
}
const _hoisted_142 = ["value", "id"]
const _hoisted_143 = ["for"]
const _hoisted_144 = { class: "content-btn d-flex justify-content-between mt-2 mb-2" }
const _hoisted_145 = ["disabled"]
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { key: 1 }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head pt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-timex fa-3x text-danger" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Desafiliar Póliza")
], -1)
const _hoisted_149 = { class: "modal-blue__head" }
const _hoisted_150 = { class: "d-flex justify-content-between" }
const _hoisted_151 = ["disabled"]
const _hoisted_152 = { key: 0 }
const _hoisted_153 = { key: 1 }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "modal-blue__head pt-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-timex fa-3x text-danger" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Afiliar Póliza")
], -1)
const _hoisted_155 = { class: "modal-blue__head" }
const _hoisted_156 = { class: "d-flex justify-content-between" }
const _hoisted_157 = ["disabled"]
const _hoisted_158 = { key: 0 }
const _hoisted_159 = { key: 1 }
const _hoisted_160 = { class: "modal-blue__head" }
const _hoisted_161 = ["src"]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("h3", null, "Ups!", -1)
const _hoisted_163 = { class: "modal-blue__head" }
const _hoisted_164 = { class: "modal-login__form" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("small", null, "Id de transacción", -1)
const _hoisted_166 = { class: "form-group mt-3" }
const _hoisted_167 = ["disabled"]
const _hoisted_168 = { key: 0 }
const _hoisted_169 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_170 = { class: "modal-login__form" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecciona el numero de meses", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1 Mes", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2 Meses", -1)
const _hoisted_174 = [
  _hoisted_171,
  _hoisted_172,
  _hoisted_173
]
const _hoisted_175 = /*#__PURE__*/_createElementVNode("small", null, "Selecciona el número de meses a congelar", -1)
const _hoisted_176 = { class: "form-group mt-3" }
const _hoisted_177 = ["disabled"]
const _hoisted_178 = { key: 0 }
const _hoisted_179 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_180 = { class: "modal-login__form" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("small", null, "Ingrese un email válido", -1)
const _hoisted_182 = { class: "form-group mt-3" }
const _hoisted_183 = ["disabled"]
const _hoisted_184 = { key: 0 }
const _hoisted_185 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_186 = {
  key: 0,
  class: "mt-2 text-success text-center"
}
const _hoisted_187 = {
  key: 1,
  class: "mt-2 text-danger text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group", { invalid: this.v$.policy.policyNumber.$error }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.v$.policy.policyNumber.$model) = $event))
                      }, null, 512), [
                        [_vModelText, this.v$.policy.policyNumber.$model]
                      ]),
                      _hoisted_10
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        style: {"width":"100%"},
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchPolicy())),
                        disabled: _ctx.flags.searching
                      }, [
                        (!_ctx.flags.searching)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Buscar"))
                          : _createCommentVNode("", true),
                        (_ctx.flags.searching)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_13)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", null, [
                        (this.policy.entityStatus !== 0 && !_ctx.flags.searching)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("button", {
                                style: {"width":"100%"},
                                type: "button",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reprocessPayments()))
                              }, [
                                (!_ctx.flags.deleting)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Reprocesar Pagos"))
                                  : _createCommentVNode("", true),
                                (_ctx.flags.deleting)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (this.policy.entityStatus !== 0 && !_ctx.flags.searching)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("button", {
                              style: {"width":"100%"},
                              type: "button",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPolicyModal()))
                            }, [
                              (!_ctx.flags.deleting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Enviar Póliza"))
                                : _createCommentVNode("", true),
                              (_ctx.flags.deleting)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", null, [
                      (this.policy.entityStatus !== 0 && !_ctx.flags.searching)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("button", {
                              style: {"width":"100%"},
                              type: "button",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openCancelConfirmModal()))
                            }, [
                              (!_ctx.flags.deleting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Anular"))
                                : _createCommentVNode("", true),
                              (_ctx.flags.deleting)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                (_ctx.flags.showPolicyData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, [
                              (this.policy.entityStatus === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                                : _createCommentVNode("", true),
                              (this.policy.entityStatus !== 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.freezed ? "Congelada" : "Activa"), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      (_ctx.freezed)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.unfreezePolicy())),
                                            disabled: _ctx.flags.unfreezing
                                          }, [
                                            (!_ctx.flags.unfreezing)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Descongelar póliza"))
                                              : _createCommentVNode("", true),
                                            (_ctx.flags.unfreezing)
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_49))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_47))
                                        : _createCommentVNode("", true),
                                      (!_ctx.freezed)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openFreezeModal())),
                                            disabled: _ctx.flags.unfreezing
                                          }, [
                                            (!_ctx.flags.unfreezing)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Congelar póliza"))
                                              : _createCommentVNode("", true),
                                            (_ctx.flags.unfreezing)
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_52))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_50))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _hoisted_55,
                            _hoisted_56,
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("span", null, _toDisplayString(this.policy.debitAutomatic ? "Si" : "No"), 1)
                              ]),
                              (_ctx.isSuperAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    (!this.policy.debitAutomatic)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "btn btn-main",
                                          type: "button",
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openAffiliateConfirmModal())),
                                          disabled: this.flags.disaffiliating
                                        }, [
                                          (!this.flags.disaffiliating)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Afiliar"))
                                            : _createCommentVNode("", true),
                                          (this.flags.disaffiliating)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_62))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_60))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _hoisted_66,
                            _hoisted_67,
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["form-group", {
                              invalid: this.v$.policy.paymentAmount.$error,
                            }])
                                }, [
                                  _hoisted_70,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.v$.policy.paymentAmount.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, this.v$.policy.paymentAmount.$model]
                                  ])
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["form-group", { invalid: this.v$.policy.expiresOn.$error }])
                                }, [
                                  _hoisted_71,
                                  _createVNode(_component_datepicker, {
                                    id: 'expiresOn',
                                    modelValue: this.v$.policy.expiresOn.$model,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.v$.policy.expiresOn.$model) = $event)),
                                    "input-class": 'form-control',
                                    format: 'dd/MM/yyyy',
                                    language: _ctx.es
                                  }, null, 8, ["modelValue", "language"]),
                                  _hoisted_72
                                ], 2),
                                _createElementVNode("div", _hoisted_73, [
                                  (this.policy.entityStatus !== 0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.save())),
                                        disabled: _ctx.flags.editing
                                      }, [
                                        (!_ctx.flags.editing)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_75, "Guardar cambios"))
                                          : _createCommentVNode("", true),
                                        (_ctx.flags.editing)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_76))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_74))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _hoisted_79,
                            _hoisted_80,
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  _hoisted_84,
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Documento",
                                        "aria-label": "Username",
                                        value: _ctx.user.identificationNumber,
                                        readonly: "",
                                        "aria-describedby": "basic-addon1"
                                      }, null, 8, _hoisted_87)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_88, [
                                  _hoisted_89,
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["input-group mb-3", {
                                  invalid: this.v$.user.email.$error,
                                }])
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Email",
                                        "aria-label": "Username",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.email) = $event)),
                                        "aria-describedby": "basic-addon1"
                                      }, null, 512), [
                                        [_vModelText, _ctx.user.email]
                                      ])
                                    ], 2)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_91, [
                                  (this.policy.entityStatus !== 0)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveUser())),
                                        disabled: _ctx.flags.editingUser
                                      }, [
                                        (!_ctx.flags.editingUser)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_93, "Guardar cambios"))
                                          : _createCommentVNode("", true),
                                        (_ctx.flags.editingUser)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_94))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_92))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.flags.showPolicyData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _hoisted_96,
                  _hoisted_97,
                  _createElementVNode("table", _hoisted_98, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_99,
                        _hoisted_100,
                        _hoisted_101,
                        _hoisted_102,
                        _hoisted_103,
                        _hoisted_104,
                        _hoisted_105,
                        (_ctx.isSuperAdmin)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_106))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.paymentId
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(item.quote > 0 ? "Prima" : "Aporte adicional"), 1),
                          _createElementVNode("td", null, _toDisplayString(item.dueDate), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.updatedOn)), 1),
                          _createElementVNode("td", null, "S/" + _toDisplayString(item.amount), 1),
                          _createElementVNode("td", null, _toDisplayString(item.transactionExternalId), 1),
                          _createElementVNode("td", null, [
                            (item.paymentStatus === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_107, "Pagado"))
                              : _createCommentVNode("", true),
                            (item.paymentStatus === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_108, "Pendiente"))
                              : _createCommentVNode("", true),
                            (item.paymentStatus === 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_109, "Congelado"))
                              : _createCommentVNode("", true),
                            (item.paymentStatus === 4)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_110, "Pendiente sin DA"))
                              : _createCommentVNode("", true),
                            (item.paymentStatus === 5)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_111, "Devuelta"))
                              : _createCommentVNode("", true),
                            (_ctx.policy.freeInstallment &&
                        item.quote === _ctx.policy.freeInstallment
                        )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_112, "Prima devuelta"))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.isSuperAdmin)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_113, [
                                (item.paymentStatus === 2 &&
                        this.policy.entityStatus !== 0
                        )
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      role: "button",
                                      title: "Marcar como pagada",
                                      class: "text-main",
                                      onClick: ($event: any) => (_ctx.openRegisterPaymentModal(item))
                                    }, [
                                      _hoisted_115,
                                      _createTextVNode("   Registrar pago ")
                                    ], 8, _hoisted_114))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("template", null, [
              _createElementVNode("form", _hoisted_117, [
                _createElementVNode("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    (_ctx.flags.showPolicyData)
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_120))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "modal-success",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "sm",
      "modal-class": "modal-blue",
      ref: "modal-success"
    }, {
      default: _withCtx(() => [
        _hoisted_121,
        _hoisted_122
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-user-success",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "sm",
      "modal-class": "modal-blue",
      ref: "modal-user-success"
    }, {
      default: _withCtx(() => [
        _hoisted_123,
        _hoisted_124
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-confirm",
      "ok-only": "",
      "ok-title": "Esta seguro de anular la poliza?",
      centered: "",
      size: "l",
      "modal-class": "modal-blue",
      ref: "modal-confirm"
    }, {
      default: _withCtx(() => [
        _hoisted_125,
        _createElementVNode("div", _hoisted_126, [
          _hoisted_127,
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              style: {"color":"#fff"},
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openPolizasPagadasModal('modal-polizas-pagadas')))
            }, " Sí "),
            _createElementVNode("button", {
              class: "btn btn-default",
              style: {"color":"#fff"},
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeModal('modal-confirm')))
            }, " No ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-polizasPagadas",
      "ok-only": "",
      "ok-title": "Listado de polizas pagadas",
      centered: "",
      size: "lg",
      "modal-class": "modal-polizasPagadas",
      ref: "modal-polizas-pagadas"
    }, {
      default: _withCtx(() => [
        _hoisted_129,
        _createElementVNode("div", _hoisted_130, [
          _createElementVNode("table", _hoisted_131, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("div", _hoisted_132, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: 'payments',
                      style: {"cursor":"pointer"},
                      checked: _ctx.paymentIds.length === _ctx.polizasPagadas.length,
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectAllPayedPolicies()))
                    }, null, 40, _hoisted_133),
                    _hoisted_134
                  ])
                ]),
                _hoisted_135,
                _hoisted_136,
                _hoisted_137,
                _hoisted_138,
                _hoisted_139
              ])
            ]),
            (_ctx.polizasPagadas.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_140, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.polizasPagadas, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.paymentId
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_141, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: item.paymentId,
                            id: 'payment-' + item.paymentId,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.paymentIds) = $event)),
                            style: {"cursor":"pointer"}
                          }, null, 8, _hoisted_142), [
                            [_vModelCheckbox, _ctx.paymentIds]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: 'payment-' + item.paymentId
                          }, null, 8, _hoisted_143)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.quote > 0 ? "Prima" : "Aporte adicional"), 1),
                      _createElementVNode("td", null, _toDisplayString(item.dueDate), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.updatedOn)), 1),
                      _createElementVNode("td", null, "S/" + _toDisplayString(item.amount), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_144, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.cancel())),
              disabled: _ctx.flags.deleting
            }, [
              (!_ctx.flags.deleting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_146, "Anular"))
                : _createCommentVNode("", true),
              (_ctx.flags.deleting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_147, "Anulando póliza..."))
                : _createCommentVNode("", true)
            ], 8, _hoisted_145),
            _createElementVNode("button", {
              class: "btn btn-default",
              style: {"color":"#fff"},
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeModal('modal-polizas-pagadas')))
            }, " No ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-confirm",
      "ok-only": "",
      "ok-title": "Esta seguro de desafiliar la poliza?",
      centered: "",
      size: "sm",
      "modal-class": "modal-blue",
      ref: "modal-confirm-desaffiliate"
    }, {
      default: _withCtx(() => [
        _hoisted_148,
        _createElementVNode("div", _hoisted_149, [
          _createElementVNode("p", null, " ¿Esta seguro de desafiliar la póliza " + _toDisplayString(this.policy.policyNumber) + " del débito automático? ", 1),
          _createElementVNode("div", _hoisted_150, [
            _createElementVNode("button", {
              class: "btn btn-default",
              style: {"color":"#fff"},
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeModal('modal-confirm-desaffiliate')))
            }, " Cerrar "),
            _createElementVNode("button", {
              class: "btn btn-danger",
              type: "button",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.desaffiliate())),
              disabled: this.flags.disaffiliating
            }, [
              (!this.flags.disaffiliating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_152, "Desafiliar"))
                : _createCommentVNode("", true),
              (this.flags.disaffiliating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_153, "Desafiliando póliza..."))
                : _createCommentVNode("", true)
            ], 8, _hoisted_151)
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-confirm",
      "ok-only": "",
      "ok-title": "Esta seguro de desafiliar la poliza?",
      centered: "",
      size: "sm",
      "modal-class": "modal-blue",
      ref: "modal-confirm-affiliate"
    }, {
      default: _withCtx(() => [
        _hoisted_154,
        _createElementVNode("div", _hoisted_155, [
          _createElementVNode("p", null, " ¿Esta seguro de afiliar la póliza " + _toDisplayString(this.policy.policyNumber) + " al débito automático? ", 1),
          _createElementVNode("div", _hoisted_156, [
            _createElementVNode("button", {
              class: "btn btn-default",
              style: {"color":"#fff"},
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.closeModal('modal-confirm-affiliate')))
            }, " Cerrar "),
            _createElementVNode("button", {
              class: "btn btn-danger",
              type: "button",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.affiliate())),
              disabled: this.flags.affiliating
            }, [
              (!this.flags.affiliating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_158, "Afiliar"))
                : _createCommentVNode("", true),
              (this.flags.affiliating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_159, "Afiliando póliza..."))
                : _createCommentVNode("", true)
            ], 8, _hoisted_157)
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "md",
      "modal-class": "modal-blue",
      ref: "modal-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_160, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/alert.svg'),
            alt: ""
          }, null, 8, _hoisted_161),
          _hoisted_162
        ]),
        _createElementVNode("div", _hoisted_163, [
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.message), 1)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-register-payment",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Registrar pago",
      ref: "modal-register-payment"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_164, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", {
          invalid: this.v$.payment.transactionId.$error,
        }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Id de transacción de Culqi",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((this.v$.payment.transactionId.$model) = $event))
            }, null, 512), [
              [_vModelText, this.v$.payment.transactionId.$model]
            ]),
            _hoisted_165
          ], 2),
          _createElementVNode("div", _hoisted_166, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.registerPayment())),
              type: "button",
              disabled: _ctx.flags.registeringPayment
            }, [
              (!_ctx.flags.registeringPayment)
                ? (_openBlock(), _createElementBlock("span", _hoisted_168, "Guardar"))
                : _createCommentVNode("", true),
              (_ctx.flags.registeringPayment)
                ? (_openBlock(), _createElementBlock("i", _hoisted_169))
                : _createCommentVNode("", true)
            ], 8, _hoisted_167)
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-freeze",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Registrar pago",
      ref: "modal-freeze"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_170, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", {
          invalid: this.v$.payment.transactionId.$error,
        }])
          }, [
            _withDirectives(_createElementVNode("select", {
              name: "",
              id: "",
              style: {"-webkit-appearance":"auto","text-align":"left"},
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.v$.freeze.months.$model) = $event)),
              class: "form-control"
            }, _hoisted_174, 512), [
              [_vModelSelect, _ctx.v$.freeze.months.$model]
            ]),
            _hoisted_175
          ], 2),
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.freezePolicy())),
              type: "button",
              disabled: _ctx.flags.unfreezing
            }, [
              (!_ctx.flags.unfreezing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_178, "Congelar póliza"))
                : _createCommentVNode("", true),
              (_ctx.flags.unfreezing)
                ? (_openBlock(), _createElementBlock("i", _hoisted_179))
                : _createCommentVNode("", true)
            ], 8, _hoisted_177)
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-policy",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Enviar póliza",
      ref: "modal-policy"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_180, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", {
          invalid: this.v$.policy.email.$error,
        }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Ingrese Email",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((this.v$.policy.email.$model) = $event))
            }, null, 512), [
              [_vModelText, this.v$.policy.email.$model]
            ]),
            _hoisted_181
          ], 2),
          _createElementVNode("div", _hoisted_182, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sendPolicy())),
              type: "button",
              disabled: _ctx.flags.sendingPolicy
            }, [
              (!_ctx.flags.sendingPolicy)
                ? (_openBlock(), _createElementBlock("span", _hoisted_184, "Enviar póliza"))
                : _createCommentVNode("", true),
              (_ctx.flags.sendingPolicy)
                ? (_openBlock(), _createElementBlock("i", _hoisted_185))
                : _createCommentVNode("", true)
            ], 8, _hoisted_183)
          ]),
          (this.flags.sendedPolicy)
            ? (_openBlock(), _createElementBlock("p", _hoisted_186, " Póliza enviada, por favor revisa tu correo. "))
            : _createCommentVNode("", true),
          (this.flags.sendedPolicyError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_187, " Ocurrió un error al enviar la póliza, vuelve a intentar en unos segundos "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}